const RecaptchaLoadTip = ({ isRecaptchaLoading, hasRecaptchaLoadFailed, onRetry }) => {
  if (isRecaptchaLoading) {
    return <p className="is-size-7 has-text-grey has-text-centered">Loading security verification...</p>;
  }

  if (!hasRecaptchaLoadFailed) {
    return null;
  }

  return (
    <>
      <p className="public-secure-file-inline-error" role="alert">
        <i className="fas fa-circle-exclamation" aria-hidden="true" />
        Unable to load security verification required to send SMS. This may be caused by your network or firewall
        blocking Google services.
      </p>
      <button type="button" className="public-secure-file-button" onClick={onRetry}>
        Try again
      </button>
    </>
  );
};

export default RecaptchaLoadTip;
